import React, { Component } from 'react';
import Terminal from 'terminal-in-react';
import noScroll from 'no-scroll';


const cake = `
            ,:/+/-
            /M/              .,-=;//;-
       .:/= ;MH/,    ,=/+%$XH@MM#@:
      -$##@+$###@H@MMM#######H:.    -/H#
 .,H@H@ X######@ -H#####@+-     -+H###@X
  .,@##H;      +XM##M/,     =%@###@X;-
X%-  :M##########$.    .:%M###@%:
M##H,   +H@@@$/-.  ,;$M###@%,          -
M####M=,,---,.-%%H####M$:          ,+@##
@##################@/.         :%H##@$-
M###############H,         ;HM##M$=
#################.    .=$M##M$=
################H..;XM##M$=          .:+
M###################@%=           =+@MH%
@#################M/.         =+H#X%=
=+M###############M,      ,/X#H+:,
  .;XM###########H=   ,/X#H+:;
     .=+HM#######M+/+HM@+=.
         ,:/%XM####H/.
              ,.:=-.

Type help to get started`;

const fox = `
,@@@            @@@/               @@@@                             
,@@@@@        @@@@@/              @@@@@@@@                          
,@@@@@@@@    @@@@@@/             (@@@@@@@@@@                        
,@@@@@@@@@@    .@@@/              @@@@@@@@@@@@@                     
,@@@@@@@@@@@@@    @/              &@@@@@@@@@@@@@@.                  
*@@@@@@@@@@@@@@@                    @@@@@@@@@@@@@@@@                
,@@@%(((((((%@@@@@@                   @@@@@@@@@@@@@@@@              
,@@@,          %@@@@@                    @@@@@@@@@@@@@@@            
,@@@,                                      @@@@@@@@@@@@@@,          
*@@@,      /#######################(.         @@@@@@@@@@@@          
,@@@,      %@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@     @@@@@@@@@&          
,@@@,      %@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@.    @@@@@@           
,@@@,      %@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@*    @@#            
,@@@,      %@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@                  
,@@@,      %@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@                 
,@@@,      %@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@(                
,@@@,      %@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@                
,@@@,      %@@@.                         &@@@@@@@@@@                
*@@@,      %@@@.              @@@@@@@@      @@@@@@@@                
,@@@,      %@@@.                @@@@@@        @@@@@@                
,@@@,      %@@@.                 @@@@@         @@@@@                
,@@@,      %@@@.                  @@@@         .@@@@                
,@@@,      %@@@.                  @@@@          @@@@                
,@@@,      %@@@.                  @@@@          @@@@
`;

class Emulator extends Component {

  componentDidMount() {
    if (typeof window !== 'undefined') {
      document.getElementsByClassName('tl-wrapper')[0].style.zIndex = 999;
      noScroll.on();
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      document.getElementsByClassName('tl-wrapper')[0].style.zIndex = 1;
      noScroll.off();
    }
  }

  showFox = () => fox

  render() {
    const closeTerminal = this.props.closeTerminal;
    const startPong = this.props.startPong;
    const showVideoOne = this.props.showVideoOne;
    const showVideoTwo = this.props.showVideoTwo;
    return (
      <>
        <div className="Emulator">
          <div className="Emulator__terminal">
            <Terminal
              color='green'
              backgroundColor='black'
              barColor='#232425'
              actionHandlers={{
                handleClose: () => {
                  closeTerminal()
                },
              }}
              allowTabs={false}
              style={{ fontWeight: "bold", fontSize: "1em" }}
              commands={{
                'pong': () => startPong(),
                'fox': this.showFox,
                'wapbamboogie': () => showVideoOne(),
                'still-alive': () => showVideoTwo(),
                'exit': () => closeTerminal(),
              }}
              descriptions={{
                color: false,
                show: false,
                'pong': 'Play pong',
                'fox': 'ASCII fox',
                'wapbamboogie': 'Get jazzy!',
                'still-alive': 'Play the still alive song',
                'exit': 'Exit the terminal',
              }}
              msg={cake}
            />
          </div>
        </div>
        <div className="Emulator__backdrop"></div>
      </>
    )
  }
}

export default Emulator